import { getAccountsApartmentKey } from "../selectors/getAccountsApartmentKey";

export function getAccountsApartmentScopedResourceName(baseName: string): string {
    const accountsApartmentKey = getAccountsApartmentKey();
    return accountsApartmentKey !== undefined ? `${baseName}-${accountsApartmentKey}` : baseName;
}
